export default __webpack_public_path__ + "static/media/IMG_01_th.345b7475.jpg";